import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Europe/London");

export const DateUtil = dayjs;
export const DisplayFormat = "HH:mm - DD/MM/YYYY";
export const EventDateFormat = "DD.MM.YYYY";
export const EventTimeFormat = "HH:mm";
export const HasuraFormat = "YYYY-MM-DDTHH:mm";
